import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import auth from './modules/auth'
import users from './modules/users'
import userDetails from './modules/userDetails'
import blacklists from './modules/blacklists'
import autofollowees from './modules/autofollowees'
import news from './modules/news'
import drafts from './modules/drafts'
import draftForm from './modules/draftForm'
import abuseReports from './modules/abuseReports'
import vouchers from './modules/vouchers'
import suggestions from './modules/suggestions'
import servers from './modules/servers'
import services from './modules/services'
import { registerPaginator } from './modules/paginator'
import { registerSort } from './modules/sort'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const logger = false // enable logger explicitly if needed for as it hurts performance

const store = new Vuex.Store({
  state: {
    CDN_URL: process.env.CDN_URL
  },
  modules: {
    auth,
    users,
    userDetails,
    blacklists,
    autofollowees,
    news,
    drafts,
    draftForm,
    abuseReports,
    vouchers,
    suggestions,
    servers,
    services
  },
  strict: debug,
  plugins: debug && logger ? [createLogger()] : []
})

registerPaginator(store, 'users')
registerPaginator(store, 'news')

registerSort(store, 'drafts')
registerPaginator(store, 'drafts')

registerSort(store, 'abuseReports', { property: 'ctime', direction: 'desc' })
registerPaginator(store, 'abuseReports')

export default store



// WEBPACK FOOTER //
// ./src/store/index.js